import { Box, Button, Grid, TextField, Typography, FormControl, FormControlLabel, RadioGroup, Radio, Dialog, DialogTitle, DialogContent, DialogContentText, } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import '../../GeneralServices/NewConnection/NewConnectionForm.scss';
import CircularProgress from '@mui/material/CircularProgress';
import { cfpBaseUrl, mnrURL } from '../../../network/urls';
import Backdrop from '@mui/material/Backdrop';
import Error from '../../../components/error/error';
import DoneIcon from '@mui/icons-material/Done';
import { dBillAPI, handleFileUpload, isImage, isPdf } from '../../../services/Functions';
import { getMNRToken } from '../../../network/APIs/APIs';
import { documentExtensions, portalName } from '../../../utils/PortalName';
import pdfIcon from "../../../images/pdfIcon.png";
import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";


const initialValues = {
    iv_consumer_id: "",
    iv_old_name: "",
    iv_old_cnic: "",
    iv_old_phone: "",
    iv_old_email: "",
    iv_new_name: "",
    iv_new_cnic: "",
    iv_new_phone_no: "",
    iv_new_email: "",
    iv_reference_number: '',
    iv_applicant_cnic_document_front: null,
    iv_applicant_cnic_document_back: null,
    iv_bill_image: null,
    iv_rent_agreement: null,
    iv_property_proof: null,
    iv_affidavite: null,
};
const CNICUpdation = () => {
    const [name, setName] = useState('')
    const [referenceNumber, setReferenceNumber] = useState('')
    const [phoneNo, setPhoneNo] = useState('')
    const [cnicNo, setCnicNo] = useState('')
    const [email, setEmail] = useState('')
    const [error, setError] = useState('');
    const [searchBy, setSearchBy] = useState('consumerId')
    const [tenantCNICUpdatePopUp, setTenantCNICUpdatePopUp] = useState(false)

    const errorCloses = () => {
        setError('')
    }

    // const [email, setEmail] = useState('')
    const [viewBackdrop, setViewBackdrop] = useState(false);

    const token = JSON.parse(window.localStorage.getItem('user-token'));

    const SearchBy = (event) => {
        values.iv_search_by = event.target.value;
        setSearchBy(event.target.value);
        setName()
        setPhoneNo()
        setEmail()
        setCnicNo()
        values.iv_consumer_id = ""
        values.iv_reference_number = ""
        values.iv_old_name = ""
        values.iv_old_cnic = ""
        values.iv_old_phone = ""
        values.iv_old_email = ""
        values.iv_new_name = ""
        values.iv_new_cnic = ""
        values.iv_new_phone_no = ""
        values.iv_new_email = ""
        setApplicantCnicDocumentFront()
        setApplicantCnicDocumentBack()
        setPropertyProof()
        setRentAgreement()
        setBillImage()
        setAffidavite()
        setApplicantCnicDocumentFrontThumbnail()
        setApplicantCnicDocumentBackThumbnail()
        setPropertyProofThumbnail()
        setRentAgreementThumbnail()
        setBillImageThumbnail()
        setAffidaviteThumbnail()
        setApplicantCnicDocumentFrontError()
        setApplicantCnicDocumentBackError()
        setPropertyProofError()
        setRentAgreementError()
        setBillImageError()
        setAffidaviteError()
    };

    const [applicantCnicDocumentFront, setApplicantCnicDocumentFront] = useState("");
    const [applicantCnicDocumentBack, setApplicantCnicDocumentBack] = useState("");
    const [propertyProof, setPropertyProof] = useState("");
    const [rentAgreement, setRentAgreement] = useState("");
    const [affidavite, setAffidavite] = useState("");
    const [billImage, setBillImage] = useState("");

    const [applicantCnicDocumentFrontError, setApplicantCnicDocumentFrontError] = useState("");
    const [applicantCnicDocumentBackError, setApplicantCnicDocumentBackError] = useState("");
    const [propertyProofError, setPropertyProofError] = useState("");
    const [rentAgreementError, setRentAgreementError] = useState("");
    const [affidaviteError, setAffidaviteError] = useState("");
    const [billImageError, setBillImageError] = useState("");

    const [applicantCnicDocumentFrontThumbnail, setApplicantCnicDocumentFrontThumbnail] = useState("");
    const [applicantCnicDocumentBackThumbnail, setApplicantCnicDocumentBackThumbnail] = useState("");
    const [propertyProofThumbnail, setPropertyProofThumbnail] = useState("");
    const [rentAgreementThumbnail, setRentAgreementThumbnail] = useState("");
    const [affidaviteThumbnail, setAffidaviteThumbnail] = useState("");
    const [billImageThumbnail, setBillImageThumbnail] = useState("");

    const ApplicantCnicDocumentFront = (event) => {
        if (event.target.files) {
            const newFileName = 'copyOfApplicantCNICFront.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setApplicantCnicDocumentFront, setApplicantCnicDocumentFrontError, setApplicantCnicDocumentFrontThumbnail, newFileName);
        }
    };

    const ApplicantCnicDocumentBack = (event) => {
        if (event.target.files) {
            const newFileName = 'copyOfApplicantCNICBack.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setApplicantCnicDocumentBack, setApplicantCnicDocumentBackError, setApplicantCnicDocumentBackThumbnail, newFileName);
        }
    };

    const PropertyProof = (event) => {
        if (event.target.files) {
            const newFileName = 'propertyProof.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setPropertyProof, setPropertyProofError, setPropertyProofThumbnail, newFileName);
        }
    };

    const RentAgreement = (event) => {
        if (event.target.files) {
            const newFileName = 'rentAgreement.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setRentAgreement, setRentAgreementError, setRentAgreementThumbnail, newFileName);
        }
    };

    const Affidavite = (event) => {
        if (event.target.files) {
            const newFileName = 'affidavite.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setAffidavite, setAffidaviteError, setAffidaviteThumbnail, newFileName);
        }
    };

    const BillImage = (event) => {
        if (event.target.files) {
            const newFileName = 'billImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setBillImage, setBillImageError, setBillImageThumbnail, newFileName);
        }
    };

    const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({

        initialValues,
        validationSchema: Yup.object({
            iv_reference_number: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'referenceNo',
                then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
                otherwise: Yup.string().optional()
            }),
            iv_consumer_id: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'consumerId',
                then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
                otherwise: Yup.string().optional()
            }),
            iv_old_name: Yup.string().optional(),
            iv_old_cnic: Yup.mixed().optional(),
            iv_old_phone: Yup.mixed().optional(),
            iv_old_email: Yup.mixed().optional(),
            iv_new_name: Yup.string().min(3, 'New name must be at least 3 characters.').max(30, 'New name must not be more than 30 characters.').required("Enter new Name."),
            //Newemail:Yup.string().email().required("This field is must"),
            iv_new_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.")
                .min(11, "Please enter 11 digit phone number.")
                .required("Enter new mobile number.")
                .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
            iv_new_cnic: Yup.string().min(13, "Please enter 13 digit CNIC.")
                .max(13, "Please enter 13 digit CNIC.")
                .required("Enter new CNIC number.")
                .matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
            iv_new_email: Yup.string()
                .email("Enter email as 'john@gmail.com'.")
                .required("Enter new email."),
            iv_applicant_cnic_document_front: Yup.mixed().required("Please upload CNIC Front image in jpg, jpeg, png or pdf format."),
            // iv_applicant_cnic_document_back: Yup.mixed().required("Please upload CNIC Back image in jpg, jpeg, png or pdf format."),
            iv_bill_image: Yup.mixed().required("Please upload Bill image in jpg, jpeg, png or pdf format."),
            iv_rent_agreement: Yup.mixed().required("Please upload Rent Agreement image in jpg, jpeg, png or pdf format."),
            iv_property_proof: Yup.mixed().required("Please upload Property Proof image in jpg, jpeg, png or pdf format."),
            iv_affidavite: Yup.mixed().required("Please upload Affidavite image in jpg, jpeg, png or pdf format."),
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true);

            const token = await getMNRToken();
            console.log(token, 'printing token')
            if (token) {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

                const urlencoded = new URLSearchParams();
                urlencoded.append("ref_no", referenceNumber);
                urlencoded.append("owner_name", values.iv_old_name);
                urlencoded.append("owner_cnic", values.iv_old_cnic);
                urlencoded.append("owner_mobile", values.iv_old_phone);
                urlencoded.append("occup_name", values.iv_new_name);
                urlencoded.append("occup_cnic", values.iv_new_cnic);
                urlencoded.append("occup_mobile", values.iv_new_phone_no);
                urlencoded.append("occup_image", applicantCnicDocumentFrontThumbnail.split(',')[1]);
                urlencoded.append("bill_image", billImageThumbnail.split(',')[1]);
                urlencoded.append("rent_agreement", rentAgreementThumbnail.split(',')[1]);
                urlencoded.append("property_proof", propertyProofThumbnail.split(',')[1]);
                urlencoded.append("affidavit", affidaviteThumbnail.split(',')[1]);
                urlencoded.append("source", portalName);
                urlencoded.append("key", token);

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: urlencoded,
                    redirect: "follow"
                };

                await fetch(mnrURL + "save_cnicapi.php", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status) {
                            setViewBackdrop(false)
                            setTenantCNICUpdatePopUp(true)
                        }
                        else {
                            setViewBackdrop(false)
                        }
                    }).catch(error => {
                        setViewBackdrop(false)
                    });
                resetForm();
                setName();
                setCnicNo();
                setPhoneNo();
                setEmail();
                setApplicantCnicDocumentFront()
                setApplicantCnicDocumentBack()
                setPropertyProof()
                setRentAgreement()
                setBillImage()
                setAffidavite()
                setApplicantCnicDocumentFrontThumbnail()
                setApplicantCnicDocumentBackThumbnail()
                setPropertyProofThumbnail()
                setRentAgreementThumbnail()
                setBillImageThumbnail()
                setAffidaviteThumbnail()
                setApplicantCnicDocumentFrontError()
                setApplicantCnicDocumentBackError()
                setPropertyProofError()
                setRentAgreementError()
                setBillImageError()
                setAffidaviteError()
            }
            setViewBackdrop(false)
        }
    })

    // Calling Billing API to fetch near by details
    useEffect(() => {
        if (values.iv_consumer_id.length === 10) {
            referenceApi();
        } else {
            setError('')
            setName()
            setEmail()
            setCnicNo()
            setPhoneNo()
            values.iv_new_cnic = ''
            values.iv_new_name = ''
            values.iv_new_email = ''
            values.iv_new_phone_no = ''
            values.iv_old_name = ""
            values.iv_old_cnic = ""
            values.iv_old_phone = ""
            values.iv_old_email = ""
            values.iv_reference_number = ''
            setApplicantCnicDocumentFront()
            setApplicantCnicDocumentBack()
            setPropertyProof()
            setRentAgreement()
            setBillImage()
            setAffidavite()
            setApplicantCnicDocumentFrontThumbnail()
            setApplicantCnicDocumentBackThumbnail()
            setPropertyProofThumbnail()
            setRentAgreementThumbnail()
            setBillImageThumbnail()
            setAffidaviteThumbnail()
            setApplicantCnicDocumentFrontError()
            setApplicantCnicDocumentBackError()
            setPropertyProofError()
            setRentAgreementError()
            setBillImageError()
            setAffidaviteError()
        }
    }, [values.iv_consumer_id])

    useEffect(() => {
        if (values.iv_reference_number.length === 14) {
            referenceApi();
        } else {
            setError('')
            setName()
            setEmail()
            setCnicNo()
            setPhoneNo()
            values.iv_new_cnic = ''
            values.iv_consumer_id = ''
            values.iv_new_name = ''
            values.iv_new_email = ''
            values.iv_old_name = ""
            values.iv_old_cnic = ""
            values.iv_old_phone = ""
            values.iv_old_email = ""
            values.iv_new_phone_no = ''
            setApplicantCnicDocumentFront()
            setApplicantCnicDocumentBack()
            setPropertyProof()
            setRentAgreement()
            setBillImage()
            setAffidavite()
            setApplicantCnicDocumentFrontThumbnail()
            setApplicantCnicDocumentBackThumbnail()
            setPropertyProofThumbnail()
            setRentAgreementThumbnail()
            setBillImageThumbnail()
            setAffidaviteThumbnail()
            setApplicantCnicDocumentFrontError()
            setApplicantCnicDocumentBackError()
            setPropertyProofError()
            setRentAgreementError()
            setBillImageError()
            setAffidaviteError()
        }
    }, [values.iv_reference_number])

    const referenceApi = async () => {
        if (searchBy === 'consumerId') {
            setViewBackdrop(true)
            if (!values.iv_consumer_id) return;
            let apiResponse = await dBillAPI(token, values.iv_consumer_id)
            if (apiResponse.status) {
                const basicInfo = apiResponse.basicInfo
                setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
                values.iv_old_name = basicInfo.consumerName
                values.iv_old_cnic = basicInfo.occupant_cnic
                values.iv_old_phone = basicInfo.consumerContactNo
                values.iv_old_email = basicInfo.consumerEmail
            } else {
                console.log('Reference No. not found!')
            }
            setViewBackdrop(false)
        }
        if (searchBy === 'referenceNo') {
            setViewBackdrop(true)
            if (!values.iv_reference_number) return;
            let apiResponse = await dBillAPI(token, values.iv_reference_number)
            if (apiResponse.status) {
                const basicInfo = apiResponse.basicInfo
                setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
                values.iv_old_name = basicInfo.consumerName
                values.iv_old_cnic = basicInfo.occupant_cnic
                values.iv_old_phone = basicInfo.consumerContactNo
                values.iv_old_email = basicInfo.consumerEmail
            } else {
                console.log('Reference No. not found!')
            }
            setViewBackdrop(false)
        }
    };

    return (
        <>
            <Grid container className="nC">
                <Box className='nCContainer'>
                    <div className="headingBarDiv">
                        <h3 className="heading">
                            Update Tenant CNIC
                        </h3>
                    </div>
                    <form className='ncform'>
                        <Typography variant="h6" className="groupTitle">
                            <div className="redCell">
                            </div>
                            Connection Details
                        </Typography>
                        <Grid container className='container'>
                            <Grid item xs={3}>
                                <Typography className="fieldLabel"> Search By</Typography>
                                <FormControl className="form-control">
                                    <RadioGroup
                                        className="radio-group"
                                        row
                                        name="iv_search_by"
                                        defaultValue={searchBy}
                                        value={searchBy}
                                        onChange={SearchBy}
                                    >
                                        <FormControlLabel
                                            value="consumerId"
                                            className="form-control-label"
                                            control={<Radio />}
                                            label="Customer ID."
                                            name="consumerId"
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            value="referenceNo"
                                            className="form-control-label"
                                            control={<Radio />}
                                            label="Reference No."
                                            name="referenceNo"
                                            labelPlacement="end"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {
                                searchBy === 'consumerId' &&
                                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                                    <Typography className='fieldLabel' >Customer ID.</Typography>
                                    <TextField
                                        required
                                        type='double'
                                        name="iv_consumer_id"
                                        value={values.iv_consumer_id}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 10 }}
                                        onBlur={handleBlur}
                                        label=""
                                        id="iv_consumer_id"
                                        placeholder=''
                                        className='textInputField'
                                    />
                                    <Box className='from-Error'>
                                        {
                                            errors.iv_consumer_id && touched.iv_consumer_id ? (
                                                errors.iv_consumer_id
                                            ) : null
                                        }
                                    </Box>
                                </Grid>
                            }
                            {
                                searchBy === 'referenceNo' &&
                                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                                    <Typography className='fieldLabel' >Reference No. </Typography>
                                    <TextField
                                        required
                                        type='double'
                                        name="iv_reference_number"
                                        value={values.iv_reference_number}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 14 }}
                                        onBlur={handleBlur}
                                        label=""
                                        id="iv_reference_number"
                                        placeholder=''
                                        size='small'
                                        className='textInputField'
                                    />
                                    <Box className='from-Error'>
                                        {
                                            errors.iv_reference_number && touched.iv_reference_number ? (
                                                errors.iv_reference_number
                                            ) : null
                                        }
                                    </Box>
                                </Grid>
                            }
                        </Grid>
                        <Typography variant="h6" className="groupTitle">
                            <div className="cyanCell">
                            </div>
                            Current Information
                        </Typography>
                        <Grid container className='container'>
                            <Grid item xs={3} sx={{ paddingRight: '20px' }}>
                                <Typography className='fieldLabel' >Name</Typography>
                                <TextField
                                    margin="normal"
                                    disabled
                                    type='name'
                                    name="iv_old_name"
                                    value={values.iv_old_name}
                                    label=""
                                    id="iv_old_name"
                                    placeholder=''
                                    className='textInputField1'
                                />
                            </Grid>
                            <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                                <Typography className='fieldLabel' >CNIC</Typography>
                                <TextField
                                    margin="normal"
                                    disabled
                                    type='number'
                                    name="iv_old_cnic"
                                    value={values.iv_old_cnic}
                                    inputProps={{ maxLength: 13 }}
                                    label=""
                                    id="iv_old_cnic"
                                    placeholder=''
                                    size='small'
                                    className='textInputField1'
                                />
                            </Grid>
                            <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                                <Typography className='fieldLabel' >Phone No.</Typography>
                                <TextField
                                    margin="normal"
                                    disabled
                                    type='number'
                                    name="iv_old_phone"
                                    label=""
                                    inputProps={{ maxLength: 11 }}
                                    value={values.iv_old_phone}
                                    id="iv_old_phone"
                                    placeholder=''
                                    size='small'
                                    className='textInputField1'
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Typography className='fieldLabel' >Email</Typography>
                                <TextField
                                    margin="normal"
                                    disabled
                                    type='number'
                                    name="iv_old_email"
                                    label=""
                                    value={values.iv_old_email}
                                    id="iv_old_email"
                                    placeholder=''
                                    size='small'
                                    className='textInputField1'
                                />
                            </Grid>
                        </Grid>
                        <Typography variant="h6" className="groupTitle">
                            <div className="purpleCell">
                            </div>
                            New Information
                        </Typography>
                        <Grid container className='container'>
                            <Grid item xs={3} sx={{ paddingRight: '20px' }}>
                                <Typography className='fieldLabel' >Name</Typography>
                                <TextField
                                    margin="normal"
                                    required
                                    type='text'
                                    name="iv_new_name"
                                    value={values.iv_new_name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label=""
                                    id="newName"
                                    placeholder=''
                                    size='small'
                                    className='textInputField'
                                />
                                <Box className='from-Error'>
                                    {
                                        errors.iv_new_name && touched.iv_new_name ? (
                                            errors.iv_new_name
                                        ) : null
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                                <Typography className='fieldLabel' >CNIC</Typography>
                                <TextField
                                    margin="normal"
                                    required
                                    type='text'
                                    name="iv_new_cnic"
                                    inputProps={{ maxLength: 13 }}
                                    value={values.iv_new_cnic}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label=""
                                    id="newCnicNo"
                                    placeholder=''
                                    size='small'
                                    className='textInputField'
                                />
                                <Box className='from-Error'>
                                    {
                                        errors.iv_new_cnic && touched.iv_new_cnic ? (
                                            errors.iv_new_cnic
                                        ) : null
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                                <Typography className='fieldLabel' >Phone No.</Typography>
                                <TextField
                                    margin="normal"
                                    required
                                    type='text'
                                    name="iv_new_phone_no"
                                    label=""
                                    inputProps={{ maxLength: 11 }}
                                    value={values.iv_new_phone_no}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    id="newNumber"
                                    placeholder=''
                                    size='small'
                                    className='textInputField'

                                />
                                <Box className='from-Error'>
                                    {
                                        errors.iv_new_phone_no && touched.iv_new_phone_no ? (
                                            errors.iv_new_phone_no
                                        ) : null
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography className='fieldLabel' >Email</Typography>
                                <TextField
                                    margin="normal"
                                    required
                                    type='double'
                                    name="iv_new_email"
                                    label=""
                                    value={values.iv_new_email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    id="iv_new_email"
                                    placeholder=''
                                    size='small'
                                    className='textInputField'

                                />
                                <Box className='from-Error'>
                                    {
                                        errors.iv_new_email && touched.iv_new_email ? (
                                            errors.iv_new_email
                                        ) : null
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} className="documentsContainer">
                            <Grid item lg={1.25}>
                                <Typography className="documentLabel">
                                    1- Applicant's CNIC.
                                </Typography>
                                <Box className="documentError">
                                    {errors.iv_applicant_cnic_document_front &&
                                        touched.iv_applicant_cnic_document_front
                                        ? errors.iv_applicant_cnic_document_front
                                        : null}
                                </Box>
                                {/* <Box className="documentError">
                                    {errors.iv_applicant_cnic_document_back &&
                                        touched.iv_applicant_cnic_document_back
                                        ? errors.iv_applicant_cnic_document_back
                                        : null}
                                </Box> */}
                            </Grid>
                            <Grid item lg={1.5}>
                                {applicantCnicDocumentFront ? (
                                    <>
                                        <Button
                                            varient="outlined"
                                            component="label"
                                            startIcon={
                                                <CloseIcon
                                                    className="button-with-image"
                                                    onClick={() => {
                                                        setApplicantCnicDocumentFront("");
                                                    }}
                                                />
                                            }
                                        >
                                            {applicantCnicDocumentFrontThumbnail &&
                                                isImage(applicantCnicDocumentFront) ? (
                                                <div className="btn-div">
                                                    <img
                                                        src={applicantCnicDocumentFrontThumbnail}
                                                        alt="Applicant CNIC Front"
                                                        width="80"
                                                    />
                                                    {/* <p>{applicantCnicDocumentFrontFileName}</p> */}
                                                </div>
                                            ) : (
                                                <span>
                                                    {isPdf(applicantCnicDocumentFront) ? (
                                                        <div className="btn-div">
                                                            <img src={pdfIcon} alt="PDF" width="80" />
                                                            {/* <p>{applicantCnicDocumentFrontFileName}</p> */}
                                                        </div>
                                                    ) : (
                                                        "Other file type"
                                                    )}
                                                </span>
                                            )}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            startIcon={<FileUploadOutlinedIcon />}
                                            className="btn"
                                        >
                                            Upload
                                            <input
                                                hidden
                                                accept={documentExtensions}
                                                id="iv_applicant_cnic_document_front"
                                                name="iv_applicant_cnic_document_front"
                                                type="file"
                                                onChange={ApplicantCnicDocumentFront}
                                            />
                                        </Button>
                                        <Box className="documentError">
                                            {applicantCnicDocumentFront == '' ?
                                                applicantCnicDocumentFrontError : null
                                            }
                                        </Box>
                                    </>
                                )}
                            </Grid>
                            {/* <Grid item lg=".875">
                                {applicantCnicDocumentBack ? (
                                    <>
                                        <Button
                                            component="label"
                                            startIcon={
                                                <CloseIcon
                                                    className="button-with-image"
                                                    onClick={() => {
                                                        setApplicantCnicDocumentBack("");
                                                    }}
                                                />
                                            }
                                        >
                                            {applicantCnicDocumentBackThumbnail &&
                                                isImage(applicantCnicDocumentBack) ? (
                                                <div className="btn-div">
                                                    <img
                                                        src={applicantCnicDocumentBackThumbnail}
                                                        alt="Applicant CNIC Back"
                                                        width="80"
                                                    />
                                                </div>
                                            ) : (
                                                <span>
                                                    {isPdf(applicantCnicDocumentBack) ? (
                                                        <div className="btn-div">
                                                            <img src={pdfIcon} alt="PDF" width="80" />
                                                        </div>
                                                    ) : (
                                                        "Other file type"
                                                    )}
                                                </span>
                                            )}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            startIcon={<FileUploadOutlinedIcon />}
                                            className="btn"
                                        >
                                            Back
                                            <input
                                                hidden
                                                accept={documentExtensions}
                                                id="iv_applicant_cnic_document_back"
                                                name="iv_applicant_cnic_document_back"
                                                type="file"
                                                onChange={ApplicantCnicDocumentBack}
                                            />
                                        </Button>
                                        <Box className="documentError">
                                            {
                                                applicantCnicDocumentBack == '' ?
                                                    applicantCnicDocumentBackError : null
                                            }
                                        </Box>
                                    </>
                                )}
                            </Grid> */}
                            <Grid item lg={1.5}>
                                <Typography className="documentLabel">
                                    2- Property Proof
                                </Typography>
                                <Box className="documentError">
                                    {" "}
                                    {errors.iv_property_proof && touched.iv_property_proof
                                        ? errors.iv_property_proof
                                        : null}
                                </Box>
                            </Grid>
                            <Grid item lg={1.5}>
                                {propertyProof ? (
                                    <>
                                        <Button
                                            component="label"
                                            startIcon={
                                                <CloseIcon
                                                    className="button-with-image"
                                                    onClick={() => {
                                                        setPropertyProof("");
                                                    }}
                                                />
                                            }
                                        >
                                            {propertyProofThumbnail &&
                                                isImage(propertyProof) ? (
                                                <div className="btn-div">
                                                    <img
                                                        src={propertyProofThumbnail}
                                                        alt="Property Documents"
                                                        width="80"
                                                    />
                                                    {/* <p>{propertyProofFileName}</p> */}
                                                </div>
                                            ) : (
                                                <span>
                                                    {isPdf(propertyProof) ? (
                                                        <div className="btn-div">
                                                            <img src={pdfIcon} alt="PDF" width="80" />
                                                            {/* <p>{propertyProofFileName}</p> */}
                                                        </div>
                                                    ) : (
                                                        "Other file type"
                                                    )}
                                                </span>
                                            )}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            startIcon={<FileUploadOutlinedIcon />}
                                            className="btn"
                                        >
                                            Upload
                                            <input
                                                hidden
                                                accept={documentExtensions}
                                                id="iv_property_proof"
                                                name="iv_property_proof"
                                                type="file"
                                                onChange={PropertyProof}
                                            />
                                        </Button>
                                        <Box className="documentError">
                                            {propertyProof == '' ?
                                                propertyProofError : null
                                            }
                                        </Box>
                                    </>
                                )}
                            </Grid>
                            <Grid item lg={1.5}>
                                <Typography className="documentLabel">
                                    3- Rental Agreement
                                </Typography>
                                <Box className="documentError">
                                    {" "}
                                    {errors.iv_rent_agreement && touched.iv_rent_agreement
                                        ? errors.iv_rent_agreement
                                        : null}
                                </Box>
                            </Grid>
                            <Grid item lg={1.5}>
                                {rentAgreement ? (
                                    <>
                                        <Button
                                            component="label"
                                            startIcon={
                                                <CloseIcon
                                                    className="button-with-image"
                                                    onClick={() => {
                                                        setRentAgreement("");
                                                    }}
                                                />
                                            }
                                        >
                                            {rentAgreementThumbnail &&
                                                isImage(rentAgreement) ? (
                                                <div className="btn-div">
                                                    <img
                                                        src={rentAgreementThumbnail}
                                                        alt="Rent Agreement"
                                                        width="80"
                                                    />
                                                    {/* <p>{propertyProofFileName}</p> */}
                                                </div>
                                            ) : (
                                                <span>
                                                    {isPdf(rentAgreement) ? (
                                                        <div className="btn-div">
                                                            <img src={pdfIcon} alt="PDF" width="80" />
                                                            {/* <p>{propertyProofFileName}</p> */}
                                                        </div>
                                                    ) : (
                                                        "Other file type"
                                                    )}
                                                </span>
                                            )}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            startIcon={<FileUploadOutlinedIcon />}
                                            className="btn"
                                        >
                                            Upload
                                            <input
                                                hidden
                                                accept={documentExtensions}
                                                id="iv_rent_agreement"
                                                name="iv_rent_agreement"
                                                type="file"
                                                onChange={RentAgreement}
                                            />
                                        </Button>
                                        <Box className="documentError">
                                            {rentAgreement == '' ?
                                                rentAgreementError : null
                                            }
                                        </Box>
                                    </>
                                )}
                            </Grid>
                            <Grid item lg={1.5}>
                                <Typography className="documentLabel">
                                    4- Bill Image
                                </Typography>
                                <Box className="documentError">
                                    {" "}
                                    {errors.iv_bill_image && touched.iv_bill_image
                                        ? errors.iv_bill_image
                                        : null}
                                </Box>
                            </Grid>
                            <Grid item lg={1.5}>
                                {billImage ? (
                                    <>
                                        <Button
                                            component="label"
                                            startIcon={
                                                <CloseIcon
                                                    className="button-with-image"
                                                    onClick={() => {
                                                        setBillImage("");
                                                    }}
                                                />
                                            }
                                        >
                                            {billImageThumbnail &&
                                                isImage(billImage) ? (
                                                <div className="btn-div">
                                                    <img
                                                        src={billImageThumbnail}
                                                        alt="Bill"
                                                        width="80"
                                                    />
                                                    {/* <p>{propertyProofFileName}</p> */}
                                                </div>
                                            ) : (
                                                <span>
                                                    {isPdf(billImage) ? (
                                                        <div className="btn-div">
                                                            <img src={pdfIcon} alt="PDF" width="80" />
                                                            {/* <p>{propertyProofFileName}</p> */}
                                                        </div>
                                                    ) : (
                                                        "Other file type"
                                                    )}
                                                </span>
                                            )}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            startIcon={<FileUploadOutlinedIcon />}
                                            className="btn"
                                        >
                                            Upload
                                            <input
                                                hidden
                                                accept={documentExtensions}
                                                id="iv_bill_image"
                                                name="iv_bill_image"
                                                type="file"
                                                onChange={BillImage}
                                            />
                                        </Button>
                                        <Box className="documentError">
                                            {billImage == '' ?
                                                billImageError : null
                                            }
                                        </Box>
                                    </>
                                )}
                            </Grid>

                            <Grid item lg={1.5}>
                                <Typography className="documentLabel">
                                    5- Affidavite
                                </Typography>
                                <Box className="documentError">
                                    {" "}
                                    {errors.iv_affidavite && touched.iv_affidavite
                                        ? errors.iv_affidavite
                                        : null}
                                </Box>
                            </Grid>
                            <Grid item lg={1.5}>
                                {affidavite ? (
                                    <>
                                        <Button
                                            component="label"
                                            startIcon={
                                                <CloseIcon
                                                    className="button-with-image"
                                                    onClick={() => {
                                                        setAffidavite("");
                                                    }}
                                                />
                                            }
                                        >
                                            {affidaviteThumbnail &&
                                                isImage(affidavite) ? (
                                                <div className="btn-div">
                                                    <img
                                                        src={affidaviteThumbnail}
                                                        alt="Affidavite"
                                                        width="80"
                                                    />
                                                    {/* <p>{propertyProofFileName}</p> */}
                                                </div>
                                            ) : (
                                                <span>
                                                    {isPdf(affidavite) ? (
                                                        <div className="btn-div">
                                                            <img src={pdfIcon} alt="PDF" width="80" />
                                                            {/* <p>{propertyProofFileName}</p> */}
                                                        </div>
                                                    ) : (
                                                        "Other file type"
                                                    )}
                                                </span>
                                            )}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            startIcon={<FileUploadOutlinedIcon />}
                                            className="btn"
                                        >
                                            Upload
                                            <input
                                                hidden
                                                accept={documentExtensions}
                                                id="iv_affidavite"
                                                name="iv_affidavite"
                                                type="file"
                                                onChange={Affidavite}
                                            />
                                        </Button>
                                        <Box className="documentError">
                                            {affidavite == '' ?
                                                affidaviteError : null
                                            }
                                        </Box>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                        {
                            error &&
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        }
                        <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
                            <Button className={((values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) && values.iv_new_name != '' && values.iv_new_cnic.length === 13 && values.iv_new_phone_no.length === 11) === false ? 'disabled-button' : 'button'}
                                variant="contained" component="label" type='submit' onClick={handleSubmit} disabled={((values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) && values.iv_new_name != '' && values.iv_new_cnic.length === 13 && values.iv_new_phone_no.length === 11) === false} >
                                Submit
                            </Button>
                        </Box>
                    </form >
                </Box>
            </Grid >

            < Dialog
                open={tenantCNICUpdatePopUp}
                onClose={() => setTenantCNICUpdatePopUp(false)}
                className='dialog'
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{ style: { width: '100%', height: '45%', borderRadius: 20 } }}
            >
                <DialogTitle  >
                    <Box className="backgroundAttached" >
                        <DoneIcon className="icon" />
                    </Box>
                    <Typography variant="h6" className="groupTitle"> Data Updated</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p className="applicationSubmit">  Tenant Data updated successfully for Reference No. : {referenceNumber}.</p>
                        {/* <p className="trackIdPara"> Your Application ID.</p> */}
                        {/* <p className="trackId"> {applicationID}</p> */}
                    </DialogContentText>
                </DialogContent>
            </Dialog >

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    );
}
export default CNICUpdation;
